"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var mobx_apollo_1 = __importDefault(require("mobx-apollo"));
var without_typename_1 = require("./without-typename");
exports.withoutTypename = without_typename_1.withoutTypename;
var fast_memoize_1 = __importDefault(require("fast-memoize"));
function createGraphqlClient(client, defaultApiErrorHandler) {
    var _this = this;
    var mutation = function (graphqlMutation) {
        return function (variables, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var alertErrors, apolloOptions, response, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            alertErrors = options.alertErrors, apolloOptions = __rest(options, ["alertErrors"]);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, client.mutate(__assign({ variables: variables, mutation: graphqlMutation }, apolloOptions))];
                        case 2:
                            response = _a.sent();
                            if (response.errors && response.errors.length) {
                                throw response.errors[0];
                            }
                            if (!response.data) {
                                throw new Error('Could not get data');
                            }
                            return [2 /*return*/, response.data];
                        case 3:
                            e_1 = _a.sent();
                            if (alertErrors) {
                                defaultApiErrorHandler(e_1);
                            }
                            throw e_1;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
    };
    var query = function (graphqlQuery) {
        function createQuery(variables, options) {
            if (options === void 0) { options = {}; }
            var alertErrors = options.alertErrors, keepTypenames = options.keepTypenames, mobxApolloOptions = __rest(options, ["alertErrors", "keepTypenames"]);
            var observableQuery = mobx_apollo_1.default(__assign({ client: client, query: graphqlQuery, variables: variables }, mobxApolloOptions, { onError: function (error) {
                    if (alertErrors) {
                        defaultApiErrorHandler(error);
                    }
                } }));
            var result = {
                ref: observableQuery.ref,
            };
            mobx_1.extendObservable(result, {
                get loading() { return observableQuery.loading; },
                get data() {
                    if (observableQuery.loading || observableQuery.error) {
                        return undefined;
                    }
                    if (keepTypenames) {
                        return observableQuery.data;
                    }
                    return without_typename_1.withoutTypename(mobx_1.toJS(observableQuery.data));
                },
                get error() { return observableQuery.error; },
            });
            return result;
        }
        return fast_memoize_1.default(createQuery);
    };
    return { mutation: mutation, query: query };
}
exports.createGraphqlClient = createGraphqlClient;
